
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.6 29.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.4 3.7l-4.8 22.1H9L4.1 3.7h20.3M26.7 0H1.8C.8 0 0 .8 0 1.8v.4L5.7 28c.2.8.9 1.4 1.8 1.5h13.6c.9 0 1.6-.6 1.8-1.5l5.7-25.8c.2-1-.4-2-1.4-2.2h-.5z","opacity":".64","fill":"#fff"}})])
          )
        }
      }
    